import { requestGet } from '@/common/request';

export default {
  pool: {
    list(query) {
      return requestGet('/promotion/pool/list', query);
    },
    add(query) {
      return requestGet('/promotion/pool/add', query);
    },
  },
};
